const allowedModules = [
    'Client'
];
if (!allowedModules.includes(global.MODULE)) throw new Error(`Only allowed in ${allowedModules.join(', ')}`);
export * from './common/index.ts';
